export enum CompanyStorageDisposition {
  ATTACHMENT = 'attachment',
  INLINE = 'inline',
}
